// Shared content-width wrapper class for list/management pages (Properties-style
// layout: `<div className='min-h-screen ... p-6'><div className={PAGE_CONTENT_WIDTH}>...`).
// Change this once to resize every page that uses it. Settings and Support Chat
// intentionally have their own layout and don't use this.
export const PAGE_CONTENT_WIDTH = 'w-[95%] mx-auto';

export const getStatusColor = (status) => {
  switch (status) {
    case 'confirmed':
      return 'bg-blue-100 text-blue-600';
    case 'completed':
      return 'bg-green-100 text-green-600';
    case 'pending':
      return 'bg-yellow-100 text-yellow-600';
    case 'cancelled':
      return 'bg-red-100 text-red-600';
    case 'rescheduled':
      return 'bg-purple-100 text-purple-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

// Formats a currency amount to at most 2 decimals, dropping trailing
// floating-point noise (e.g. 199.42000000000002 -> "199.42").
export const formatAmount = (value) =>
  Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const getTypeColor = (type) => {
  return type === 'tour'
    ? 'bg-indigo-100 text-indigo-600'
    : 'bg-orange-100 text-orange-600';
};